import './index.scss';
import { array, object } from 'prop-types';
import React from 'react';
import ResponsiveItem from '~/components/responsive_item';
const ClassificationResults = ({ filteredCategories, selectedCategories, setSelectedCategories, filteredDescriptors, selectedDescriptors, setSelectedDescriptors, }) => {
    ClassificationResults.propTypes = {
        filteredCategories: array.isRequired,
        filteredDescriptors: array.isRequired,
        state: object.isRequired,
    };
    const handleSelectCategory = (item) => {
        const hasCategory = selectedCategories.indexOf(item);
        if (hasCategory > -1) {
            const newCategories = [...selectedCategories];
            newCategories.splice(hasCategory, 1);
            setSelectedCategories(newCategories);
            return;
        }
        setSelectedCategories([...selectedCategories, item]);
    };
    const handleSelectDescriptor = (item) => {
        const hasDescriptor = selectedDescriptors.indexOf(item);
        if (hasDescriptor > -1) {
            const newDescriptors = [...selectedDescriptors];
            newDescriptors.splice(hasDescriptor, 1);
            setSelectedDescriptors(newDescriptors);
            return;
        }
        setSelectedDescriptors([...selectedDescriptors, item]);
    };
    return (React.createElement("div", { className: 'overflow-scroll-gradient' },
        React.createElement("div", { className: 'classification-results-container' },
            React.createElement("div", { className: 'classification-results-header' },
                React.createElement("h5", { className: 'classification-results-list-header' },
                    React.createElement("b", null, "CATEGORY"),
                    "(",
                    filteredCategories.length,
                    ")"),
                React.createElement("h5", { className: 'classification-results-list-header' },
                    React.createElement("b", { style: { marginLeft: '10px' } }, "DESCRIPTOR"),
                    "(",
                    filteredDescriptors.length,
                    ")")),
            React.createElement("div", { className: 'classification-results-body' },
                React.createElement("div", { className: 'classification-results-list' }, filteredCategories.map(filteredCategory => {
                    const isActive = selectedCategories.includes(filteredCategory);
                    return (React.createElement(ResponsiveItem, { key: `filtered-category-${filteredCategory}`, onClick: () => handleSelectCategory(filteredCategory), overflowText: filteredCategory, wrapperClassName: `classification-results-item${isActive ? ' active' : ''}` }, filteredCategory));
                })),
                React.createElement("div", { className: 'classification-results-list' }, filteredDescriptors.map(filteredDescriptor => {
                    const isActive = selectedDescriptors.includes(filteredDescriptor);
                    return (React.createElement(ResponsiveItem, { key: `filtered-descriptor-${filteredDescriptor}`, onClick: () => handleSelectDescriptor(filteredDescriptor), overflowText: filteredDescriptor, wrapperClassName: `classification-results-item${isActive ? ' active' : ''}` }, filteredDescriptor));
                }))))));
};
export default ClassificationResults;
